<script lang="ts">
  import Map from "./Map.svelte";
  import type { Installator } from "$lib/types/installator";
  import { page } from "$app/state";
  import Breadcrumb from "$lib/Breadcrumb.svelte";
  import DiscountBanner from "../../DiscountBanner.svelte";
  import MetaData from "$lib/MetaData.svelte";

  interface Props {
    data: {
      sikringsskap: Installator[];
      elbil: Installator[];
      vvb: Installator[];
      elkontroll: Installator[];
      apiKey: string;
      produkt: {
        product_categories: string[];
        typeform_name: string;
        typeform_id: string;
        title: string;
        campaign?: string;
        not_available?: boolean;
      };
    };
  }

  let { data }: Props = $props();

  const slug = $derived(page.params.product || "");
  const product = $derived(
    slug
      .replace(/-/g, " ")
      .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase())
  );
  const productName = $derived(data.produkt?.title);
  let installatorer: Installator[] = $state([]);
  let typeform = $state("");

  let apiKey = $derived(data.apiKey);
  let productCategory = $derived(data.produkt?.product_categories);

  $effect(() => {
    if (productCategory?.includes("sikringsskap")) {
      typeform = "e1my31bv";
      installatorer = data.sikringsskap;
    } else if (productCategory?.includes("elbillader")) {
      typeform = "gEDXubEi";
      installatorer = data.elbil;
    } else if (productCategory.includes("varmtvannsbereder")) {
      typeform = "AnmdiZAY";
      installatorer = data.vvb;
    } else if (productCategory.includes("elkontroll")) {
      typeform = "cQ5RWU0V";
      installatorer = data.elkontroll;
    }
  });
</script>

<MetaData
  data={{
    title: `Bestill ${productName}`,
    description: "Sjekk nærmeste installatør og bestill her.",
  }}
/>

<Breadcrumb
  breadcrumbs={[
    { label: "Forside", href: "/" },
    { label: "Nettbutikk", href: `/nettbutikk` },
    {
      label: productName || "",
      href: slug ? `/nettbutikk/${slug}` : "",
    },
    { label: "Bestill", href: "" },
  ]}
/>

<section class="mx-$space-edge-x">
  {#if data.produkt && !data.produkt?.not_available}
    <h1>Du har valgt {productName}</h1>

    <p class="heading-2">
      Velg adresse ut fra hvor du ønsker å installere laderen. Det er 50 km tur/retur inkludert i
      standard installasjon. Eventuelle reiseutgifter, eksempelvis bruk av ferge og ekstra reisetid
      kan medføre en tilleggskostnad fra installatør.
    </p>
    <DiscountBanner />

    {#if installatorer.length !== 0}
      <Map
        {installatorer}
        {apiKey}
        product={data?.produkt?.typeform_name || product}
        productId={data?.produkt?.typeform_id}
        campaign={data?.produkt?.campaign}
        {typeform}
      />
    {:else}
      <p class="heading-2">Feil ved lasting av data</p>
    {/if}
  {:else}
    <h1>Vi tilbyr ikke lengre {productName}</h1>
    <p class="max-w-prose">
      Beklager det, men ta gjerne en titt på våre andre produkter i nettbutikken.
    </p>
  {/if}
</section>
